import { html } from '@microsoft/fast-element';

export const ExecutionKnowledgeBlock = html`
  <div class="knowledge-block-modal-content">
    <h1 class="title ">Overview</h1>
    <p>
      This page displays those Transaction Negotiations that require final execution for the RFQ
      Method of Execution or those that have successfully been Auto Executed.
    </p>

    <p>
      Executed Transactions are captured in Regulatory Reporting and shared with Regulators
      appropriately.
    </p>

    <p>
      The Execution Summary displayed is that of the Transaction Negotiation selected on the
      relevant tab. The default Execution Summary displayed when selecting a tab, is that of the
      first record in the list.
    </p>

    <h1 class="title ">RFQ Method</h1>

    <p>
      These Transaction Negotiations have had successful negotiations in the Engagements module and
      the legal Transaction Confirmation (Contract) has been signed in the Contracting module.
    </p>

    <p>
      Transaction Negotiations that are executed on this page, result in a Transaction that is
      legally binding.
    </p>

    <p class="item">Execution Period</p>

    <p>
      Transaction Execution can only occur between the hours of 09:00 ET and 17:00 ET, during this
      period the heading of the module will display as Execution Deadline with a time clock that
      indicates the time remaining in which execution can occur.
    </p>
    <p>
      The Execute action cannot be withdrawn unless the Timeclock expires AND the other party does
      not select Execute.
    </p>
    <p>
      The Timeclock will expire at 5pm ET at the end of the same day for any trade that is ready to
      execute before 5pm ET on that day, and will expire at 5pm EST the next business day for any
      trade ready to execute after 5pm ET or on a non-business day.
    </p>
    <p>
      Execution cannot occur between the hours of 17:00 ET and 09:00 ET and on non-Business Days.
      NYSE Bank holidays are observed.
    </p>
    <p>
      Once the transaction execution period has expired, the heading of the module will display as
      Executed Contracts, and the time clock will no longer be displayed.
    </p>

    <p class="item">Awaiting Confirmation</p>

    <p>
      This tab shows all Transaction Negotiations that are Ready for Execution and a Status Pill
      that indicates the status and action outstanding.
    </p>

    <p>
      All Executed Transactions are removed from this tab at 17:00 ET. All Executed Transactions for
      the RFQ Method of Execution can be viewed on the Executed Tab in the Dashboard.
    </p>

    <p>
      Selecting the Execute button in the execution summary for a negotiation record results in
      Transaction execution.
    </p>

    <p>
      Selecting the Return to Contracting module removes the Negotiation from the Execution Module
      and returns the user to the contracting module for that Negotiation.
    </p>

    <p class="item ">Expired</p>

    <p>
      This tab shows all Transaction Negotiations where the Negotiation has not been executed by
      both parties by 17:00 ET. The execution process can be restarted in the Contracting module.
    </p>

    <h1 class="title ">Auto-Execute Contracts</h1>

    <p>
      Displays all auto-executed Transactions for reference purposes. All executed transactions for
      the Auto-Execution Method can be viewed on the Executed Tab in the Dashboard.
    </p>

    <p>Transaction Execution can only occur between the hours of 09:00 ET and 17:00 ET.</p>
  </div>
`;
